export var breakdownsTypes = [{
  id: 'stock-sector',
  title: 'Sectorial',
  description: 'Exposición por sectores'
}, {
  id: 'regional-exposure',
  title: 'Regional',
  description: 'Exposición regional'
}, {
  id: 'asset-allocation',
  title: 'Asset allocation',
  description: 'Exposición por asset allocation'
}, {
  id: 'market-capitalization',
  title: 'Capitalización',
  description: 'Exposición por capitalización de mercado'
}];